import { useRef, useState } from "react";

const NavigationBar = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  const inputRef = useRef();

  const handleNav = () => {
      inputRef.current.checked = false;
      setClick(false);
  }

  return (
    <div>
      
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <a href="#home" className="nav-logo-link">
              <span style={{ margin: "10px" }}>ABHISHEK</span>
            </a>
          </div>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <a href="#about" className="nav-links" onClick={handleNav}>
                About
              </a>
            </li>
            <li className="nav-item">
              <a href="#skills" className="nav-links" onClick={handleNav}>
                Skills
              </a>
            </li>
            <li className="nav-item">
              <a href="#work" className="nav-links" onClick={handleNav}>
                Projects
              </a>
            </li>
            <li className="nav-item">
              <a href="#contact" className="nav-links" onClick={handleNav}>
                Contact
              </a>
            </li>
          </ul>
          <div id="menuToggle" onClick={handleClick}>
            <input type="checkbox" ref={inputRef}/>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default NavigationBar;
